/**
 * Remove acentos de uma string para busca case-insensitive
 * @param {string} text - Texto para normalizar
 * @returns {string} Texto sem acentos e em minúsculas
 */
export const removeAccents = (text) => {
  if (!text) return '';
  
  return text
    .normalize('NFD') // Decompõe caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Remove marcas diacríticas
    .toLowerCase();
};

/**
 * Verifica se um texto contém um termo de busca (ignorando acentos)
 * @param {string} text - Texto onde buscar
 * @param {string} searchTerm - Termo a buscar
 * @returns {boolean} true se encontrou
 */
export const searchWithoutAccents = (text, searchTerm) => {
  if (!text || !searchTerm) return false;
  
  return removeAccents(text).includes(removeAccents(searchTerm));
};

/**
 * Formata valor em moeda brasileira
 * @param {number} value - Valor a formatar
 * @returns {string} Valor formatado
 */
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { 
    style: 'currency', 
    currency: 'BRL' 
  }).format(value);
};

/**
 * Formata data no padrão brasileiro
 * @param {string} dateString - Data em formato ISO
 * @returns {string} Data formatada DD/MM/YYYY
 */
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR');
};
